export default "__VITE_ASSET__DqXWTfcr__"